import { useParams } from 'react-router-dom';

export const useResourceId = () => {
  const params = useParams();
  const getResourceId = () => {
    const pathname = window.location.pathname;

    if (params.techTalkId) return params.techTalkId;
    if (params.courseId) return params.courseId;
    if (params.type) return params.type;

    const storedId = sessionStorage.getItem('_activityId');
    if (storedId) return storedId;

    return null;
  };

  const getResourceType = () => {
    const pathname = window.location.pathname;

    if (pathname.includes('/techtalk/')) return 'TechTalk';
    if (pathname.includes('/course-detail/')) return 'CourseDetail';
    if (pathname.includes('/course/')) return 'Course';
    if (pathname.includes('/lms/')) return 'Activity';

    return 'Unknown';
  };

  const isValidId = (id) => {
    return id && typeof id === 'string' && id.trim().length > 0;
  };

  const getResourceInfo = () => {
    const id = getResourceId();
    const type = getResourceType();
    const isValid = isValidId(id);

    return {
      id,
      type,
      isValid,
      pathname: window.location.pathname,
      search: window.location.search,
      fullUrl: window.location.pathname + window.location.search
    };
  };

  return {
    id: getResourceId(),
    type: getResourceType(),
    isValid: isValidId(getResourceId()),
    params,
    getResourceInfo,
    getResourceId,
    getResourceType
  };
};

export const extractResourceIdFromPath = (pathname) => {
  const pathSegments = pathname.split('/').filter(Boolean);
  const resourceIndex = pathSegments.findIndex(segment => 
    ['techtalk', 'course'].includes(segment)
  );

  if (resourceIndex !== -1 && resourceIndex + 1 < pathSegments.length) {
    return pathSegments[resourceIndex + 1];
  }

  return null;
};
